import React, { useState } from 'react'
import RealtyType from '../../../models/Realty'
import Modal from '../../Modal'
import { RealtyButton } from './styles'
import RealtyDetails from '../../Realty/Details'
import RealtyCard from '../../Realty/Card'

interface Props {
  realty: RealtyType
  onUpdated: () => void
}

const Realty: React.FC<Props> = ({ realty, onUpdated }) => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <RealtyButton
        onClick={() => setOpen(true)}
      >
        <RealtyCard
          realty={realty}
        />
      </RealtyButton>

      <Modal
        title="Imóvel"
        open={open}
        onToggle={open => setOpen(open)}
      >
        <RealtyDetails
          realty={realty}
          onUpdated={onUpdated}
        />
      </Modal>
    </>
  )
}

export default Realty
